<template>
    <div id="LmQmsButtonBuilderUi" class="row align-items-center">
      <div class="container">

      <b-card no-body class="border">
        <b-tabs card>
          <b-tab :title="$t('general')" active>
            <h5 class="col-12">{{ $t('settings') }}</h5>
            <LmTextInput
              class="col-12"
              v-model="component.componentProps.label"
              @input="$emit('input', component)"
              :label="$t('title')"
              :help="$t('qms_title_help')"
            />
            <div class="container">
              <div class="row">
                <LmNumberInput
                  :id="`min-length-${id}`"
                  class="col-12 col-md-6"
                  v-model="component.componentProps.validations.minLength"
                  @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
                  :label="$t('min_length')"
                  />
                <LmNumberInput
                  :id="`max-length-${id}`"
                  class="col-12 col-md-6"
                  v-model="component.componentProps.validations.maxLength"
                  @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
                  :label="$t('max_length')"
                  />
              </div>
            </div>
            <LmSelect
              class="col-12"
              v-model="component.componentProps.align"
              :options="alignOptions"
              :label="$t('align')"
              :help="$t('align_help')"
              @input="$emit('input', component)"
            />
            <h5 class="col-12">{{ $t('buttons_visual_attributes') }}</h5>
            <hr class="w-100 mx-2">
            <div class="container">
              <div class="row">
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.buttonColor"
                />
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('background_color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.buttonBgColor"
                />
              </div>
            </div>

            <h5 class="col-12">{{ $t('qms_delete_button_visual_attributes') }}</h5>
            <hr class="w-100 mx-2">
            <div class="container">
              <div class="row">
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.deleteButtonColor"
                />
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('background_color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.deleteButtonBgColor"
                />
              </div>
            </div>

            <h5 class="col-12">{{ $t('qms_backspace_button_visual_attributes') }}</h5>
            <hr class="w-100 mx-2">
            <div class="container">
              <div class="row">
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.backspaceButtonColor"
                />
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('background_color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.backspaceButtonBgColor"
                />
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('accept_button')">
            <h5 class="col-12">{{ $t('settings') }}</h5>
            <LmSelect
              class="col-12"
              v-model="component.componentProps.okButton.componentProps.selectedScreen"
              :options="{
                content: filteredScreens
              }"
              :label="$t('select_screen')"
              :help="$t('qms_select_screen_help')"
              @input="$emit('input', component)"
            />
            <LmTextInput
              class="col-12"
              v-model="component.componentProps.okButton.componentProps.name"
              @input="$emit('input', component)"
              :label="$t('name')"
              :help="$t('qms_name_button_help')"
            />
            <hr class="w-100 mx-2">
            <h5 class="col-12">{{ $t('button_visual_attributes') }}</h5>
            <div class="container">
              <div class="row">
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.okButton.componentProps.buttonColor"
                />
                <LmColorPicker
                  class="form-group col-12 col-md-6"
                  :showFallback="true"
                  shapes="squares"
                  :label="$t('background_color')"
                  :help="$t('color_help')"
                  v-model="component.componentProps.okButton.componentProps.buttonBgColor"
                />
              </div>
            </div>
            <LmSelect
              class="col-12"
              v-model="component.componentProps.okButton.componentProps.buttonAlign"
              :options="alignOptions"
              :label="$t('align')"
              :help="$t('align_help')"
              @input="$emit('input', component)"
            />
          </b-tab>
        </b-tabs>
      </b-card>
      </div>
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmNumberInput from '@/components/form/elements/LmNumberInput'

export default {
  data () {
    return {
      component: {},
      alignOptions: {
        content: [
          { value: 'justify-start', text: this.$t('left') },
          { value: 'justify-center', text: this.$t('centered') },
          { value: 'justify-end', text: this.$t('right') }
        ]
      },
      deleteTypeOptions: {
        content: [{
          value: 'put',
          text: this.$t('logic')
        }, {
          value: 'delete',
          text: this.$t('permanent')
        }]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmCheckbox,
    LmButton,
    LmColorPicker,
    LmNumberInput
  },
  props: {
    id: {
      type: Number
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: '',
          componentName: 'LmButton',
          componentProps: {
            isVisible: true,
            align: 'center'
          }
        }
      )
    },
    screens: {
      type: Array
    },
    availableProcesses: {
      type: Array
    }
  },
  computed: {
    filteredScreens () {
      return this.screens?.map((s, index) => {
        return {
          value: index,
          text: s.title
        }
      }).filter(s => s?.value !== this.component.componentProps.currentScreenId)
    }
  },
  methods: {
  },
  created () {
    this.component = this.componentData
  }
}
</script>
